import Slogan from "../components/Slogan";
import Advantages from "../components/Advantages";
import Training from "../components/Training";
import Benchmarks from "../components/Benchmarks";
import Footer from "../components/Footer";
import Products from "../components/Products";
import Download from "../components/Download";
import Capabilities from "../components/Capabilities";

export default function Home() {
  return (
    <>
      <Slogan />
      <Advantages />
      <Capabilities />
      <Training />
      <Benchmarks />
      <Products />
      <Download />
      <Footer />
    </>
  );
}


